import React, {useEffect, useState, useContext } from "react";
import { useApi } from '../../context/ApiProvider';
import { Context } from '../../context/Context';
import { NavLink, useSearchParams } from "react-router-dom";

export default function ResetPassword(props) {
    const Api = useApi();

    const [isCheckingSuccess, setIsCheckingSuccess] = useState(false);
    const [isCheckingError, setIsCheckingError] = useState(false);
    
    let isChecking = false;

    //Hämta hashen
    const [queryParams] = useSearchParams();
    const hashParam = queryParams.get("confirmnewpass");

    useEffect(() => {
        checkRequestHash();
    }, []);

    function checkRequestHash() {
        if(isChecking) { //Eftersom useEffect körs två gånger
            return;
        }

        isChecking = true;

        setIsCheckingError(false);
        setIsCheckingSuccess(false);

        Api.checkRequestHash({ hash: `${hashParam}` })
        .then((result) => {
            setIsCheckingSuccess("A new password has been sent to your e-mail address.");
          }).catch(error => {
            setIsCheckingError("Error: Invalid link.");
          });
    }

    return (
        <main className="loginScreen">
            <section className="loginForm">
                <p>
                <img src="/images/Rolf_Logo_Color_RGB.svg" height="48" alt="Rolf" />
                </p>
                <div className="card">
                    <h1>Request new password</h1>
                    {isCheckingError && <p className='formControlError'>{isCheckingError}</p>}
                    {isCheckingSuccess && <p className='formControlSuccess'>{isCheckingSuccess}</p>}
                </div>
                <NavLink to="/">Back to login</NavLink>
            </section>
        </main>

    );

}